var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("出库管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              {
                attrs: {
                  to: {
                    name: "addInternal",
                    query: {
                      totalPrice: this.totalPrice,
                      receivedMoney: this.receivedMoney,
                      tableData: this.orderDetailList,
                      internalex: this.basic,
                    },
                  },
                },
              },
              [_c("div", { staticClass: "div3" }, [_vm._v("添加内部出库")])]
            ),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("订单审核")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "basic" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("基本信息")]),
        _c(
          "el-form",
          {
            ref: "basic",
            attrs: {
              inline: true,
              model: _vm.basic,
              rules: _vm.rules,
              "label-width": "80px",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "收货人", prop: "name" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入收货人姓名" },
                  model: {
                    value: _vm.basic.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.basic, "name", $$v)
                    },
                    expression: "basic.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "联系电话", prop: "phone" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入联系电话" },
                  model: {
                    value: _vm.basic.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.basic, "phone", $$v)
                    },
                    expression: "basic.phone",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "部门选择", prop: "orgName" } },
              [
                _c(
                  "div",
                  { staticClass: "selectTree" },
                  [
                    _c("treeselect", {
                      attrs: {
                        options: _vm.optionsTeam,
                        "search-nested": "",
                        normalizer: _vm.normalizer,
                        noResultsText: "未找到",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.basic.orgName,
                        callback: function ($$v) {
                          _vm.$set(_vm.basic, "orgName", $$v)
                        },
                        expression: "basic.orgName",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: "出库类型", prop: "type" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择出库类型",
                      filterable: "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.basic.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.basic, "type", $$v)
                      },
                      expression: "basic.type",
                    },
                  },
                  _vm._l(_vm.brandselect, function (items) {
                    return _c("el-option", {
                      key: items.id,
                      attrs: { label: items.deliveryName, value: items.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "地区", required: "" } },
              [
                _c("levelAddr", {
                  staticClass: "addressContent",
                  attrs: {
                    province: _vm.basic.province,
                    city: _vm.basic.city,
                    area: _vm.basic.area,
                  },
                  on: {
                    updateprovice: _vm.getAddrData,
                    updatecity: _vm.getCity,
                    updatearea: _vm.getArea,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "详细地址", prop: "detail" } },
              [
                _c(
                  "div",
                  { staticClass: "length" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入详细地址" },
                      model: {
                        value: _vm.basic.detail,
                        callback: function ($$v) {
                          _vm.$set(_vm.basic, "detail", $$v)
                        },
                        expression: "basic.detail",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "orderBox" }, [
      _c(
        "div",
        { staticClass: "order" },
        [
          _c(
            "p",
            {
              staticClass: "header",
              staticStyle: { background: "#fff", padding: "10px" },
            },
            [_vm._v("订单商品")]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.orderDetailList },
            },
            [
              _c("el-table-column", {
                attrs: { label: "商品名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _vm._v(_vm._s(scope.row.title || scope.row.name)),
                          scope.row.goodsType == "赠品"
                            ? _c("span", { staticClass: "gift" }, [
                                _vm._v("赠品"),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", { staticStyle: { color: "#999999" } }, [
                          _vm._v("x" + _vm._s(scope.row.quantity)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "sellPrice" }, [
                          _vm._v(" ￥" + _vm._s(scope.row.retailPrice) + " "),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "商品品牌" },
              }),
              _c("el-table-column", {
                attrs: { prop: "categoryName", label: "商品分类" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品规格" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.specTitle
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.specTitle),
                              },
                            })
                          : _c("p", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.specification),
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品小计" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                parseFloat(
                                  scope.row.quantity * scope.row.retailPrice
                                ).toFixed(2)
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "page1" }, [
        _c("p", [
          _c("span", [_vm._v("总计：共 " + _vm._s(_vm.totalNumber) + " 件 ")]),
        ]),
        _c(
          "p",
          [
            _c("span", [_vm._v("总价:")]),
            _c("el-input", {
              attrs: { disabled: true, placeholder: "" },
              model: {
                value: _vm.totalPrice,
                callback: function ($$v) {
                  _vm.totalPrice = $$v
                },
                expression: "totalPrice",
              },
            }),
          ],
          1
        ),
        _c(
          "p",
          [
            _c("span", [_vm._v("已收款:")]),
            _c("el-input", {
              attrs: { disabled: true, placeholder: "" },
              model: {
                value: _vm.receivedMoney,
                callback: function ($$v) {
                  _vm.receivedMoney = $$v
                },
                expression: "receivedMoney",
              },
            }),
          ],
          1
        ),
        _c(
          "p",
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.toReviewOrder("basic")
                  },
                },
              },
              [_vm._v("确定订单")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "orderNotes" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "notes" },
        [
          _c("el-input", {
            attrs: { type: "textarea", disabled: "", placeholder: "备注" },
            model: {
              value: _vm.basic.textarea,
              callback: function ($$v) {
                _vm.$set(_vm.basic, "textarea", $$v)
              },
              expression: "basic.textarea",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("订单备注")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }